<template>
	<div v-if="isVisible" class="px-4 formField">
		<masked-text-field-wrapper :disabled="formField.Readonly"
								   :input-mask="formField.InputMask"
								   @keyup="uppercase"
								   :class="getUppercaseClass"
								   v-model="selectedValue"
								   :label="formField.Label"
								   clearable
								   :rules="validationRules"
								   type="number"
								   hide-details="auto">
			<template v-slot:append-outer v-if="canRetainValue">
				<v-icon v-if="!hasRetainedValue" @click="onPinClick">mdi-pin-off-outline</v-icon>
				<v-icon v-else
						color="primary"
						class="rotate45"
						@click="onPinClick">mdi-pin-outline</v-icon>
			</template>
			<template v-slot:prepend v-if="visibleBubble || visibleHelp">
				<div v-if="visibleBubble">
					<v-tooltip top
							   nudge-top="20"
							   :open-on-click="true"
							   :open-on-focus="true"
							   :open-on-hover="true">
						<template v-slot:activator="{ on, attrs }">
							<v-icon color="primary"
									v-bind="attrs"
									v-on="on"
									tabindex="-1">mdi-information-outline</v-icon>
						</template>
						{{ bubbleText }}
					</v-tooltip>
				</div>
				<div v-if="visibleHelp">
					<v-tooltip top
							   nudge-top="20"
							   :open-on-click="true"
							   :open-on-focus="true"
							   :open-on-hover="true">
						<template v-slot:activator="{ on, attrs }">
							<v-icon color="primary"
									v-bind="attrs"
									v-on="on"
									tabindex="-1">mdi-help-circle-outline</v-icon>
						</template>
						{{ helpText }}
					</v-tooltip>
				</div>
			</template>
		</masked-text-field-wrapper>
	</div>
</template>
<script>
	import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
	import MaskedTextFieldWrapper from './MaskedTextFieldWrapper.vue';

	export default {
		name: 'NumberField',
		mixins: [formFieldMixin],
		components: {
			MaskedTextFieldWrapper,
		},
		mounted() {
			this.defaultRules.push((v) => {
				if (this.formField.Required && !this.isBulkEdit) {
					if (!v) return false || 'The value is required';
					else return true;
				} else return true;
			});
			this.defaultRules.push((v) => {
				if (!v) return true;
				return /^\d+$/.test(v) || 'Invalid Number format!';
			});
			if (this.recordSelectedValue) {
				this.selectedValue = this.recordSelectedValue;
			}
		},
		methods: {
			onRecordChanged() {
				if (
					this.recordSelectedValue &&
					this.selectedValue != this.recordSelectedValue
				) {
					this.selectedValue = this.recordSelectedValue;
					return;
				}

				if (
					this.selectedValue &&
					this.selectedValue != this.recordSelectedValue
				) {
					this.selectedValue = null;
				}
			},
			onHideFormField() {
				this.selectedValue = null;
			},
			onSelectedValueChanged(newVal) {
				this.skipNextRecordUpdate = true;
				this.$emit('selectedValueChanged', [
					{ key: this.recordKeys[0], value: newVal },
				]);
			},
			onSetInteraction(setValue) {
				this.onSelectedValueChanged(setValue);
			},
			onClearInteraction() {
				this.onSelectedValueChanged(null);
			},
		},
	};
</script>
